export const TradeshowStatus = Object.freeze({
  Active: 1,
  Postponed: 2,
  Cancelled: 3,
});
